import cacheSmartTimeExtendedPropertyAction from '../actions/cacheSmartTimeExtendedPropertyAction';
import SmartTimeResponse from '../services/SmartTimeResponse';
import { ClientItem, SmartTimeExtendedProperty } from 'owa-mail-store';
import ExtendedPropertyType from 'owa-service/lib/contract/ExtendedPropertyType';
import { trace } from 'owa-trace';

const ENTITYID_KEY = '@EntityId';
const CONFIDENCE_SCORE: string = 'confidence';

export default function parseSmartTimeProperty(
    item: ClientItem,
    extendedProperty: ExtendedPropertyType
): void {
    if (!extendedProperty) {
        trace.info(
            '[getSmartTimeForItem_parseSmartTimeProperty] No smart time extended property found.'
        );
        return;
    }

    let smartTimeSuggestedProperty: SmartTimeExtendedProperty = null;
    let validProperty: boolean = false;

    try {
        const parsedProperty = JSON.parse(extendedProperty.Value) as SmartTimeResponse[];

        if (parsedProperty && parsedProperty.length > 0) {
            const smartTimeEntityId = parsedProperty[0][ENTITYID_KEY];
            const smartTimeConfidenceScore = parsedProperty[0][CONFIDENCE_SCORE];
            for (const smartTimeResponse of parsedProperty) {
                if (smartTimeResponse.times && smartTimeResponse.times.length > 0) {
                    const smartTimeSuggestion = smartTimeResponse.times[0];
                    const startTime = smartTimeSuggestion.beginingOfTimeRange;
                    const endTime = smartTimeSuggestion.endOfTimeRange;

                    smartTimeSuggestedProperty = {
                        beginingOfTimeRange: startTime,
                        endOfTimeRange: endTime,
                        duration: smartTimeSuggestion.duration,
                        entityId: smartTimeEntityId,
                        hasIntent: true,
                        confidenceScore: smartTimeConfidenceScore,
                    };
                    validProperty = true;
                }
            }
        }
    } catch (e) {
        trace.warn(
            '[getSmartTimeForItem_parseSmartTimeProperty] Malformed property, cannot parse. Error: ' +
                e.message
        );
        (e as { networkError?: boolean }).networkError = true;
        throw e;
    } finally {
        cacheSmartTimeExtendedPropertyAction(item, validProperty, smartTimeSuggestedProperty);
    }
}
